export function getSplitName(name: string) {
  const tmpName = name.split('.');

  return {
    fileName: tmpName.slice(0, -1).join('.'),
    fileExtension: `.${tmpName[tmpName.length - 1]}`,
  };
}
